import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { FaSms, FaCheck } from "react-icons/fa";
import { sendSMSCourse, signatureCourse } from "../../api/commande";
import toast from "react-hot-toast";
import { useSelector } from 'react-redux'
import zIndex from "@material-ui/core/styles/zIndex";
import { useTranslation } from "react-i18next";



const sectionStyle = {
  padding: "24px",
  marginBottom: "16px",
  backgroundColor: "#F8FAFC",
  borderRadius: "12px",
  border: "1px solid #E2E8F0",
};

const title = {
  color: "#2196F3",
  fontSize: "1rem",
  fontWeight: 600,
  marginBottom: "16px",
};

const detailsTitle = {
  color: "#334155",
  fontSize: '0.9rem',
  fontWeight: 500,
  marginBottom: "8px",
};

const detailsSpan = {
  color: "#64748B",
  fontSize: "0.9rem",
};

const SignatureModal = ({ isOpen, onClose, courses }) => {
  const [codes, setCodes] = useState({});
  const [selectedPhone, setSelectedPhone] = useState({});
  const [loading, setLoading] = useState(false);
  const token = useSelector((state) => state.auth.token);
  const {t} = useTranslation()
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);

  useEffect(() => {
    const checkScreen = () => {
      const width = window.innerWidth;

      setIsMobile(width < 768);
    };
    checkScreen();
    window.addEventListener('resize', checkScreen);

    return () => window.removeEventListener('resize', checkScreen);
  }, []);
  
  const handleSendSMS = async (courseId) => {
    const numero = selectedPhone[courseId];
    if (!numero) {
      toast.error(t("select_phone_number"), {
        style: { fontFamily: "Montserrat" },
      });
      return;
    }

    setLoading(true);
    try {
      const res = await sendSMSCourse(
        { numero, courseId },
        token
      );
      toast.success(res.message, { style: { fontFamily: "Montserrat" } });
    } catch (error) {
      toast.error(t("transfer_request_err"), {
        style: { fontFamily: "Montserrat" },
      });
    } finally {
      setLoading(false);
    }
  };



  const handleValidate = async (courseId) => {
    const enteredCode = codes[courseId];
    if (!enteredCode) {
      toast.error(t("enter_sms_code"), {
        style: { fontFamily: "Montserrat" },
      });
      return;
    }

    setLoading(true);
    try {
      const response = await signatureCourse(
        { courseId, code: enteredCode },
        token
      );

      // vider le champ après succès
      setCodes({ ...codes, [courseId]: "" });

      toast.success(response.message, {
        style: { fontFamily: "Montserrat" },
      });
    } catch (error) {
      toast.error(t("invalid_code"), {
        style: { fontFamily: "Montserrat" },
      });
    } finally {
      setLoading(false);
    }
  };
  const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    padding: "0",
    borderRadius: "16px",
    border: "none",
    boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)",
    fontFamily: "Montserrat, sans-serif",
    maxHeight: "85vh",
    overflow: "hidden",
    width: isMobile? '90%' : "60%",
    maxWidth: "1000px",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.75)",
    backdropFilter: "blur(5px)",
    zIndex: 1000
  },
};

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      ariaHideApp={false}
      style={modalStyles}
    >
      <div
        style={{
          background: "linear-gradient(135deg, #5BBCEA 0%, #2196F3 100%)",
          padding: "20px",
          color: "white",
          borderTopLeftRadius: "16px",
          borderTopRightRadius: "16px",
          textAlign: "center",
        }}
      >
        <h3 style={{ margin: 0 }}>{t("trip_signatures")}</h3>
      </div>

      <div style={{ padding: "24px", overflowY: "auto", maxHeight: "70vh" }}>
        {courses?.map((course, index) => (
          <div key={course._id || index} style={sectionStyle}>
            <h4 style={title}>
              {index === 0 ? (
                <>
                  {course?.adresse_debut?.label} ➝ {course?.adresse_fin?.label}
                </>
              ) : (
                <>{course?.adresse?.label}</>
              )}
            </h4>

            <p style={detailsTitle}>
              {t("signatory")}:{" "}
              <span style={detailsSpan}>
                {course?.firstNameDistinator} {course?.lastNameDistinator}
              </span>
            </p>

            <p style={detailsTitle}>{t("contact_us_formulair_item2")} :</p>
            <div style={{ display: "flex", flexDirection: isMobile ? 'column' : 'row', gap: "12px", marginBottom: "12px" , fontSize:'0.9rem'}}>
              {course?.phone1Distinator && (
                <label>
                  <input
                    type="radio"
                    name={`phone-${course._id}`}
                    value={course.phone1Distinator}
                    checked={selectedPhone[course._id] === course.phone1Distinator}
                    onChange={() =>
                      setSelectedPhone({
                        ...selectedPhone,
                        [course._id]: course.phone1Distinator,
                      })
                    }
                  />{" "}
                  {course.phone1Distinator}
                </label>
              )}
              {course?.phone2Distinator && (
                <label>
                  <input
                    type="radio"
                    name={`phone-${course._id}`}
                    value={course.phone2Distinator}
                    checked={selectedPhone[course._id] === course.phone2Distinator}
                    onChange={() =>
                      setSelectedPhone({
                        ...selectedPhone,
                        [course._id]: course.phone2Distinator,
                      })
                    }
                  />{" "}
                  {course.phone2Distinator}
                </label>
              )}
            </div>

            <div style={{ display: "flex", gap: "12px", margin: "12px 0" }}>
              <button
                onClick={() => handleSendSMS(course._id)}
                disabled={loading}
                style={{
                  flex: 1,
                  padding: "10px",
                  backgroundColor: "#2196F3",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  cursor: "pointer",
                  opacity: loading ? 0.7 : 1,
                }}
              >
                <FaSms /> {t("send_sms")}
              </button>


            </div>

            <div style={{ display: "flex", flexDirection: isMobile ? 'column' : 'row', gap: "8px", marginTop: "8px" }}>
              <input
                type="text"
                placeholder={t("enter_code")}
                value={codes[course._id] || ""}
                onChange={(e) =>
                  setCodes({ ...codes, [course._id]: e.target.value })
                }
                style={{
                  flex: 1,
                  padding: "10px",
                  border: "1px solid #E2E8F0",
                  borderRadius: "8px",
                }}
              />
              <button
                onClick={() => handleValidate(course._id)}
                style={{
                  padding: "10px 16px",
                  backgroundColor: "#5BBCEA",
                  border: "none",
                  borderRadius: "8px",
                  color: "white",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <FaCheck /> {t("validate")}
              </button>
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default SignatureModal;
